var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMachenistLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    height: "25px",
    width: "25px",
    viewBox: "0 0 636.15 586.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#e44332",
    d: "M58.92,527.37H527.5V513.3q0-110,0-220a11.66,11.66,0,0,1,2-6.82c18-22.29,36.22-44.42,54.36-66.62a8.08,8.08,0,0,0,.85-1.83l1.38.62v5.19q0,147.74,0,295.47c0,37.64-28.69,66.75-66.32,66.82-76.49.13-153,0-229.48,0q-111.48,0-223,0c-31.75,0-57.73-19.63-65.2-49.48a75.85,75.85,0,0,1-2-18.29Q-.06,293.18,0,67.94C.05,28.29,28.56,0,68.25,0H495a38.83,38.83,0,0,1-2.2,3.48c-14.23,17.42-28.55,34.77-42.65,52.3-2.13,2.64-4.44,2.91-7.36,2.91q-158.48-.06-317-.06-30.75,0-61.49,0H58.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.65,179.37c4.12,2.21,7.93,3.39,10.58,5.82Q217.77,225,261,265.08q12.86,11.85,25.77,23.66c10.08,9.22,17.3,8.71,26.05-2q45.8-55.84,91.51-111.75Q468.28,96.9,532.23,18.78c8.07-9.85,15.36-10.62,25.14-2.63q36.2,29.55,72.33,59.18c8,6.54,8.59,14.63,1.67,23.09Q549.23,198.8,467.05,299.13q-70.92,86.63-141.83,173.25c-8.47,10.35-15.2,10.84-25.07,1.74Q195.83,377.87,91.45,281.65c-4.36-4-9.12-8.14-8.44-14.51a20.7,20.7,0,0,1,5-11Q120,220.77,152.7,186C155.42,183.08,159.74,181.67,163.65,179.37Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachenistLogo);
export default __webpack_public_path__ + "static/media/machenist-logo.d7b9293e.svg";
export { ForwardRef as ReactComponent };